<template>
    <div class="page iphone-x-adaptation switch-eat-type" v-if="!$store.getters.getPlatformId">
        <div class="error-tip">该业务已下线</div>
    </div>
    <div class="page iphone-x-adaptation switch-eat-type" :class="$store.getters.getExposeMethod.kfcIndexClass"
        :style="{ backgroundColor: $store.getters.getExposeMethod.kfcEatTypeBgColor }" v-else>
        <img class="page-bg" :src="eatTypeBg" />
        <img class="finger" src="@/assets/icons/icon-finger.png" />
        <div class="content iphone-x-adaptation">
            <div class="eat-type-list">
                <div class="item" @click="clickItem(0)"
                    :class="{ 'under-maintenance': !$store.state.common.config.enableKfcPreorder }">
                    <div class="title">自助点餐·自由加购</div>
                    <div class="tip">
                        {{ $store.getters.getExposeMethod.expandName == 'DongFu' ? '随心兑' : '5折起' }}
                    </div>
                    <img src="@/assets/images/eat-type-item-01.png" alt="" class="img" />
                    <div class="btn">日常点餐(堂食/外带)</div>
                    <img src="@/assets/icons/icon-under-maintenance.png" class="icon"
                        v-if="!$store.state.common.config.enableKfcPreorder" />
                </div>
                <template v-if="
                    // (!$store.getters.getExposeMethod.hideMtDelivery && $store.state.common.config.enableKfcDelivery && !isTakeout) || newYearShow
                    ($store.state.common.config.enableKfcDelivery && !isTakeout) || newYearShow
                ">
                    <div class="item" @click="toTripartiteDelivery" :class="{
                        'under-maintenance': !$store.state.common.config.enableKfcDelivery,
                    }">
                        <img src="@/assets/icons/icon-under-maintenance.png" class="icon"
                            v-if="!$store.state.common.config.enableKfcDelivery" />
                        <div class="title">外卖优惠点餐</div>
                        <div class="tip">宅急送</div>
                        <img src="@/assets/images/eat-type-item-03.png" class="img" />
                        <div class="btn">点餐外送</div>
                    </div>
                </template>
                <template v-else-if="true">
                <!-- <template v-else-if="$store.getters.getExposeMethod.hideMtDelivery"> -->
                    <div class="item" :class="{ 'under-maintenance': !isTakeout }" @click="clickItem(1)">
                        <img src="@/assets/icons/icon-under-maintenance.png" class="icon" v-if="!isTakeout" />
                        <div class="title">外卖比堂食更优惠</div>
                        <div class="tip">宅急送</div>
                        <img src="@/assets/icons/icon-eay-type-discount-0.png" class="icon-tip" />
                        <img src="@/assets/images/eat-type-item-02.png" class="img" />
                        <div class="btn">外卖到家(0配送费)</div>
                    </div>
                </template>
                <template v-else>
                    <div class="item">
                        <div class="title">外卖优惠点餐</div>
                        <div class="takeout-item three" :class="{
                            'under-maintenance': !$store.state.common.config.enableKfcDelivery,
                        }" @click="toTripartiteDelivery">
                            <img src="@/assets/icons/icon-under-maintenance.png" class="takeout-item-icon"
                                v-if="!$store.state.common.config.enableKfcDelivery" />
                            <div class="takeout-item-title">顺丰配送</div>
                            <div class="takeout-item-text">5折起</div>
                            <div class="takeout-item-tip">堂食菜单产品更多</div>
                            <img class="takeout-item-img" src="@/assets/icons/icon-takeout-three-sf.png" />
                        </div>
                        <div class="takeout-item official" :class="{ 'under-maintenance': !isTakeout }"
                            @click="clickItem(1)">
                            <img src="@/assets/icons/icon-under-maintenance.png" class="takeout-item-icon"
                                v-if="!isTakeout" />
                            <div class="takeout-item-title">宅急送</div>
                            <div class="takeout-item-text">6折起/免运费</div>
                            <div class="takeout-item-tip">平均30分钟速达</div>
                            <img class="takeout-item-img" src="@/assets/icons/icon-takeout-official.png" />
                        </div>
                    </div>
                </template>
            </div>
            <div class="other-store-type-list">
                <div class="ostl-item light-meal" @click="otherStoreEatType(3)">
                    <div class="icon"></div>
                    <div class="name">
                        <span>肯律</span>
                        <span class="t">轻食</span>
                    </div>
                </div>
                <div class="ostl-item coffee" @click="otherStoreEatType(2)">
                    <div class="icon"></div>
                    <div class="name">
                        <span>肯悦</span>
                        <span class="t">咖啡</span>
                    </div>
                </div>
            </div>
            <div class="customer-service-order-list">
                <div class="csrl-item order" @click="toOrder">
                    <div class="icon"></div>
                    <div class="title">我的订单</div>
                    <div class="text">查看订单进度</div>
                </div>
                <div class="csrl-item customer-service" @click="toCs">
                    <div class="icon"></div>
                    <div class="title">在线客服</div>
                    <div class="text">8:00 ~ 23:00</div>
                </div>
            </div>
            <div class="my-card" @click="toCard" v-if="!$store.getters.getExposeMethod.hideIndexOrderInlet">
                <div class="icon"></div>
                <div class="title">
                    {{
                        $store.getters.getExposeMethod.bagText
                            ? $store.getters.getExposeMethod.bagText
                            : '兑换券兑换入口（我的卡包）'
                    }}
                </div>
            </div>
            <div class="flash" v-if="bannerList.length > 0">
                <div class="swiper-container banner-swiper">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item, index) in bannerList" :key="index">
                            <img class="slide-image" :src="item.imageUrl" alt="" />
                        </div>
                    </div>
                    <div class="swiper-pagination"></div>
                </div>
            </div>
            <div class="tip">
                本产品为第三方代点餐/代配送服务！
                <br />
                即第三方代点餐，一切商业行为与官方无关。
            </div>
        </div>
        <div class="other-eat-type-dialog" v-if="eatTypeDialogVisible" @click="eatTypeDialogVisible = false">
            <div class="other-eat-type-content" @click.stop>
                <div class="other-eat-type-title">请选择取餐方式</div>
                <div class="other-eat-type-list">
                    <div class="other-eat-type-item" :class="{ select: otherStoreSelectData.select == 0 }"
                        @click="clickOtherEatType(0)">
                        <img src="~@/assets/icons/icon-eat-type-0.png" class="icon" />
                        <div class="name">堂食</div>
                        <div class="tip">到店自取</div>
                    </div>
                    <div class="other-eat-type-item" :class="{ select: otherStoreSelectData.select == 1 }"
                        @click="clickOtherEatType(1)">
                        <img src="~@/assets/icons/icon-eat-type-1.png" class="icon" />
                        <div class="name">宅急送</div>
                        <div class="tip">外卖到家</div>
                    </div>
                </div>
                <div class="submit" @click="toOtherStoreList">确认</div>
            </div>
        </div>
        <!-- <div class="customer-service-btn"
             @click="toCs">客服</div> -->
    </div>
</template>
<script>
import CustomerService from '@/components/customerService/btn.vue';
import {
    PAGE_ROOT,
    PAGE_RESTAURANT_SELECT,
    PAGE_ADDRESS_LIST,
    PAGE_STOP_MENU,
    PAGE_OLD_ORDER_LIST,
    PAGE_CUSTOMER_SERVICE,
    PAGE_KFC_RESTAURANT_CARD,
} from 'page';
import { GET_BANNER_OR_ICON } from 'api';

import Swiper from '@/lib/swiper3.4.2/swiper.min.js';
import '@/lib/swiper3.4.2/swiper.min.css';

export default {
    data() {
        return {
            isOpenBack: false,
            newYearShow: false,

            bannerList: [],
            otherStoreSelectData: {
                storeType: 0,
                select: -1,
            },
            eatTypeDialogVisible: false,
        };
    },
    components: {
        CustomerService,
    },
    computed: {
        isTakeout() {
            return this.$store.state.common.config.enableKfcTakeout || false;
        },
        eatTypeBg() {
            if (!this.$store.getters.getPlatformId) {
                return require('@/assets/images/no-bg-eat-type-bg.png');
            } else if (!this.$store.getters.getExposeMethod.kfcEatTypeBgImg) {
                return require('@/assets/images/eat-type-bg.png');
            } else {
                return this.$store.getters.getExposeMethod.kfcEatTypeBgImg;
            }
        },
    },
    beforeRouteEnter(to, form, next) {
        next(vm => {
            if (form.path == PAGE_ROOT && to.query.type == 'toCard') {
                vm.$nextTick(() => {
                    vm.toCard();
                });
            }
            if (form.path == PAGE_ROOT && to.query.type == 'toOrderList') {
                vm.$nextTick(() => {
                    vm.toOrder();
                });
            }
        });
    },
    created() {
        if (this.$route.query.backType == 2) {
            this.fobiddeBack();
        }
        // if (this.$route.query.type == 'toOrder') {
        //     this.toOrder();
        // } else if (this.$route.query.type == 'toCard') {
        //     this.toCard();
        // }

        this.getBanner();
    },
    methods: {
        getBanner() {
            this.$util.get(`${GET_BANNER_OR_ICON}/${1001}`).then(res => {
                if (res.success) {
                    this.bannerList = res.data;
                    this.bannerList &&
                        this.$nextTick(() => {
                            this.bannerSwiper = new Swiper('.banner-swiper', {
                                autoplay: 3000, //可选选项，自动滑动
                                loop: true, //可选选项，开启循环
                                pagination: {
                                    el: '.swiper-pagination',
                                    clickable: true,
                                },
                            });
                        });
                }
            });
        },
        clickItem(type = 0) {
            if (type == 0 && this.$store.state.common.config.enableKfcPreorder) {
                this.$util.umengEvent('hall_food', {
                    platformId: this.$store.getters.getPlatformId,
                    userId: this.$store.getters.userId,
                })
                this.$util.pageJump(PAGE_RESTAURANT_SELECT);
            } else if (type == 0 && !this.$store.state.common.config.enableKfcPreorder) {
                this.$toast('堂食系统维护中');
            } else if (type == 1 && this.isTakeout) {
                this.$util.umengEvent('takeout_food', {
                    platformId: this.$store.getters.getPlatformId,
                    userId: this.$store.getters.userId,
                })
                // 先按当前定位浏览菜单，加购时再选收货地址
                this.$util.pageJump(PAGE_STOP_MENU, {
                    type: 1,
                });
            } else if (type == 1 && !this.isTakeout) {
                this.$toast('当前运力紧张，暂停服务');
            }
        },
        toTripartiteDelivery() {
            if (this.$store.state.common.config.enableKfcDelivery) {
                this.$util.eventStatistics({
                    title: 'TakeoutFood',
                });
                this.$util.pageJump(PAGE_ADDRESS_LIST, {
                    type: 3,
                });
            } else {
                this.$toast('当前运力紧张，暂停服务');
            }
        },
        //防止页面后退
        fobiddeBack() {
            if (!this.isOpenBack) {
                console.log('%c防止页面后退', 'color:#da2f33');
                this.isOpenBack = true;
                history.pushState(null, null, document.URL);
                window.addEventListener('popstate', this.backCommon);
            }
        },
        //启用浏览器返回
        enableBack() {
            if (this.isOpenBack) {
                console.log('%c启用浏览器返回', 'color:#da2f33');
                this.isOpenBack = false;
                history.go(-1);
                window.removeEventListener('popstate', this.backCommon);
            }
        },
        backCommon() {
            history.pushState(null, null, document.URL);
        },
        toOrder() {
            this.$util.pageJump(PAGE_OLD_ORDER_LIST);
        },
        toCs() {
            this.$util.pageJump(PAGE_CUSTOMER_SERVICE);
        },
        toCard() {
            this.$util.pageJump(PAGE_KFC_RESTAURANT_CARD);
        },
        // 其他类型门店的就餐方式
        otherStoreEatType(storeType) {
            if (storeType == 999999999) {
                this.otherStoreSelectData.storeType = storeType;
                this.eatTypeDialogVisible = true;
            }
            else {
                return this.$toast('即将上线，敬请期待');
            }
        },
        clickOtherEatType(index) {
            this.otherStoreSelectData.select = index;
        },
        toOtherStoreList() {
            if (this.otherStoreSelectData.select == -1) {
                return this.$toast('请选择就餐方式');
            }
            if (this.otherStoreSelectData.select == 0) {
                this.$util.pageJump(PAGE_RESTAURANT_SELECT, {
                    storeType: this.otherStoreSelectData.storeType,
                });
                this.eatTypeDialogVisible = false;
            } else if (this.otherStoreSelectData.select == 1) {
                this.$util.pageJump(PAGE_STOP_MENU, {
                    type: 1,
                    storeType: this.otherStoreSelectData.storeType,
                });
                this.eatTypeDialogVisible = false;
            }
        },
    },
};
</script>

<style lang="less" scoped>
@import url('~@/lib/base.less');

.main {
    .switch-eat-type {
        min-height: calc(100vh - @tabbarHeight);
    }
}

.switch-eat-type {
    min-height: 100vh;
    font-size: 0;
    box-sizing: border-box;
}

.page-bg {
    width: 100%;
    margin-bottom: .pxToRem(24) [];
}

.finger {
    display: none;
    position: absolute;
    top: 0;
    right: .pxToRem(36) [];
    width: .pxToRem(48) [];
    height: .pxToRem(56) [];
    animation: loadingMove 1s infinite;
}

@keyframes loadingMove {
    0% {
        top: .pxToRem(0) [];
    }

    50% {
        top: .pxToRem(40) [];
    }

    100% {
        top: .pxToRem(0) [];
    }
}

/*Safari 和 Chrome:*/
@-webkit-keyframes loadingMove {
    0% {
        top: .pxToRem(0) [];
    }

    50% {
        top: .pxToRem(40) [];
    }

    100% {
        top: .pxToRem(0) [];
    }
}

.content {
    position: absolute;
    bottom: 0;
    width: 100%;
    box-sizing: border-box;

    .eat-type-list {
        padding-left: .pxToRem(30) [];
        padding-right: .pxToRem(30) [];
        .jc-sb;

        >.item {
            width: .pxToRem(330) [];
            height: .pxToRem(450) [];
            background: white;
            box-shadow: .pxToRem(3) [] .pxToRem(3) [] .pxToRem(8) [] 0 rgba(0, 0, 0, 0.1);
            border-radius: .pxToRem(40) [];
            text-align: center;

            >.icon {
                position: absolute;
                top: .pxToRem(100) [];
                left: .pxToRem(40) [];
                width: .pxToRem(240) [];
                height: .pxToRem(240) [];
                z-index: 100;
            }

            >.title {
                margin-top: .pxToRem(32) [];
                width: 100%;
                text-align: center;
                height: .pxToRem(40) [];
                line-height: .pxToRem(40) [];
                font-size: .pxToRem(32) [];
                font-weight: 600;
                color: rgba(0, 0, 0, 0.9) !important;
            }

            .tip {
                margin-top: .pxToRem(8) [];
                width: 100%;
                text-align: center;
                height: .pxToRem(60) [];
                line-height: .pxToRem(60) [];
                font-size: .pxToRem(60) [];
                font-weight: 600;
                color: @theme_color_first;
            }

            .img {
                margin-top: .pxToRem(34) [];
                width: .pxToRem(240) [];
                height: .pxToRem(140) [];
            }

            .btn {
                margin: 0 auto;
                margin-top: .pxToRem(40) [];
                margin-bottom: .pxToRem(36) [];
                width: .pxToRem(280) [];
                text-align: center;
                height: .pxToRem(60) [];
                line-height: .pxToRem(60) [];
                background: @theme_color_first;
                border-radius: .pxToRem(30) [];
                font-size: .pxToRem(24) [];
                color: white;
            }

            .icon-tip {
                position: absolute;
                bottom: .pxToRem(80) [];
                right: .pxToRem(20) [];
                width: .pxToRem(100) [];
                height: .pxToRem(44) [];
                z-index: 10;
            }

            &.under-maintenance {

                .title,
                .tip {
                    color: rgba(0, 0, 0, 0.3);
                }

                .img {
                    filter: grayscale(50%);
                }

                .btn {
                    background: rgba(0, 0, 0, 0.2);
                }

                // -webkit-filter: grayscale(100%);
                // -moz-filter: grayscale(100%);
                // -ms-filter: grayscale(100%);
                // -o-filter: grayscale(100%);
                // filter: grayscale(20%);
                // opacity: 0.3;
            }
        }

        .takeout-item {
            width: .pxToRem(298) [];
            height: .pxToRem(165) [];
            border-radius: .pxToRem(16) [];
            box-sizing: border-box;
            margin: 0 auto;
            margin-top: .pxToRem(16) [];

            .takeout-item-title {
                position: absolute;
                top: .pxToRem(20) [];
                left: .pxToRem(20) [];
                height: .pxToRem(40) [];
                line-height: .pxToRem(40) [];
                font-size: .pxToRem(30) [];
                font-weight: 600;
                color: rgba(0, 0, 0, 0.9);
            }

            .takeout-item-text {
                position: absolute;
                top: .pxToRem(76) [];
                left: .pxToRem(20) [];
                line-height: .pxToRem(40) [];
                height: .pxToRem(40) [];
                font-size: .pxToRem(30) [];
                font-weight: 600;
                color: #d90209;
                color: @theme_color_first;
            }

            .takeout-item-tip {
                position: absolute;
                top: .pxToRem(120) [];
                left: .pxToRem(20) [];
                line-height: .pxToRem(28) [];
                height: .pxToRem(28) [];
                font-size: .pxToRem(20) [];
                font-weight: 400;
                color: rgba(0, 0, 0, 0.5);
            }

            .takeout-item-img {
                position: absolute;
                bottom: .pxToRem(18) [];
                right: .pxToRem(16) [];
                height: .pxToRem(90) [];
            }

            .takeout-item-icon {
                position: absolute;
                top: 0;
                left: .pxToRem(20) [];
                width: .pxToRem(160) [];
                height: .pxToRem(160) [];
            }

            &.three {
                background: #ffeedd;
                border: .pxToRem(1) [] solid #ffdbb6;
            }

            &.official {
                background: #fdf0f0;
                border: .pxToRem(1) [] solid #feb8b8;
            }

            &+.takeout-item {
                margin-top: .pxToRem(16) [];
            }

            &.under-maintenance {
                background: rgba(0, 0, 0, 0.1);
                border-color: rgba(0, 0, 0, 0.1);

                .takeout-item-title,
                .takeout-item-text {
                    color: rgba(0, 0, 0, 0.3);
                }

                .takeout-item-img {
                    filter: grayscale(50%);
                }
            }
        }

        .icon-coming-soon {
            position: absolute;
            top: .pxToRem(103) [];
            left: .pxToRem(106) [];
            width: .pxToRem(136) [];
            height: .pxToRem(136) [];
        }
    }

    .other-store-type-list {
        display: flex;
        margin: 0 auto;
        margin-top: .pxToRem(24) [];
        width: .pxToRem(690) [];
        height: .pxToRem(128) [];

        .ostl-item {
            flex: 1;
            margin-right: .pxToRem(30) [];
            background: white;
            box-shadow: .pxToRem(3) [] .pxToRem(3) [] .pxToRem(8) [] 0 rgba(0, 0, 0, 0.1);
            border-radius: .pxToRem(24) [];

            .icon {
                .base-center-y;
                left: .pxToRem(48) [];
                width: .pxToRem(81) [];
                height: .pxToRem(84) [];
            }

            .name {
                .base-center-y;
                left: .pxToRem(148) [];
                font-size: .pxToRem(30) [];
                font-weight: bold;
                color: #000;
            }

            &.light-meal {
                .icon {
                    background: url('~@/assets/icons/icon-light-meal.png');
                    background-size: cover;
                }

                .name {
                    .t {
                        color: #0a7b1b;
                    }
                }
            }

            &.coffee {
                .icon {
                    background: url('~@/assets/icons/icon-coffee.png');
                    background-size: cover;
                }

                .name {
                    .t {
                        color: #754518;
                    }
                }
            }

            &:last-child {
                margin-right: 0;
            }
        }
    }

    .customer-service-order-list {
        display: flex;
        margin: 0 auto;
        margin-top: .pxToRem(24) [];
        width: .pxToRem(690) [];
        height: .pxToRem(128) [];
        background: white;
        box-shadow: .pxToRem(3) [] .pxToRem(3) [] .pxToRem(8) [] 0 rgba(0, 0, 0, 0.1);
        border-radius: .pxToRem(24) [];

        .csrl-item {
            flex: 1;
            border-right: .pxToRem(1) [] solid rgba(0, 0, 0, 0.15);

            .icon {
                position: absolute;
                top: .pxToRem(28) [];
                left: .pxToRem(66) [];
                width: .pxToRem(44) [];
                height: .pxToRem(44) [];
            }

            .title {
                position: absolute;
                top: .pxToRem(32) [];
                left: .pxToRem(130) [];
                height: .pxToRem(40) [];
                line-height: .pxToRem(40) [];
                font-size: .pxToRem(28) [];
                font-weight: 600;
                color: rgba(0, 0, 0, 0.9);
            }

            .text {
                position: absolute;
                bottom: .pxToRem(24) [];
                left: .pxToRem(130) [];
                height: .pxToRem(28) [];
                line-height: .pxToRem(28) [];
                font-size: .pxToRem(20) [];
                font-weight: 400;
                color: rgba(0, 0, 0, 0.5);
            }

            &.order {
                .icon {
                    background: url('~@/assets/icons/icon-order-yellow.png');
                    background-size: cover;
                }
            }

            &.customer-service {
                .icon {
                    background: url('~@/assets/icons/icon-customer-service-yellow.png');
                    background-size: cover;
                }
            }

            &:last-child {
                border-right: none;
            }
        }
    }

    .my-card {
        display: flex;
        justify-content: center;
        margin: 0 auto;
        margin-top: .pxToRem(24) [];
        width: .pxToRem(690) [];
        height: .pxToRem(88) [];
        background: white;
        box-shadow: .pxToRem(3) [] .pxToRem(3) [] .pxToRem(8) [] 0 rgba(0, 0, 0, 0.1);
        border-radius: .pxToRem(24) [];
        align-items: center;

        .icon {
            width: .pxToRem(44) [];
            height: .pxToRem(44) [];
            background: url('~@/assets/icons/icon-bag-yellow.png');
            background-size: cover;
        }

        .title {
            height: .pxToRem(44) [];
            line-height: .pxToRem(44) [];
            font-size: .pxToRem(28) [];
            font-weight: 600;
            color: rgba(0, 0, 0, 0.9);
            margin-left: .pxToRem(18) [];
        }
    }

    .banner-swiper {
        width: .pxToRem(690) [];
        margin: .pxToRem(20) [] auto 0;

        .slide-image {
            width: 100%;
            border-radius: .pxToRem(20) [];
        }
    }

    >.tip {
        text-align: center;
        line-height: .pxToRem(36) [];
        font-size: .pxToRem(24) [];
        padding-bottom: .pxToRem(36) [];
        color: rgba(0, 0, 0, 0.3);
        margin-top: .pxToRem(36) [];
    }
}

.customer-service-btn {
    position: absolute;
    top: .pxToRem(30) [];
    right: .pxToRem(0) [];
    width: .pxToRem(140) [];
    height: .pxToRem(60) [];
    line-height: .pxToRem(60) [];
    font-size: .pxToRem(20) [];
    text-indent: .pxToRem(70) [];
    color: #e02020;
    background: #ffffff;
    box-shadow: .pxToRem(3) [] .pxToRem(8) [] .pxToRem(15) [] 0px rgba(0, 0, 0, 0.15);
    border-radius: .pxToRem(100) [] 0px 0px .pxToRem(100) [];

    &:after {
        content: ' ';
        .base-center-y;
        left: .pxToRem(20) [];
        background: url('~@/assets/icons/icon-customer-service.png');
        background-repeat: no-repeat;
        background-size: cover;
        .sq(40px);
    }
}

.other-eat-type-dialog {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 100;

    .other-eat-type-content {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        background: white;
        border-radius: .pxToRem(20) [] .pxToRem(20) [] 0 0;

        .other-eat-type-title {
            height: .pxToRem(106) [];
            line-height: .pxToRem(106) [];
            font-size: .pxToRem(34) [];
            color: #000000;
            font-weight: bold;
            text-indent: .pxToRem(30) [];
            margin-top: .pxToRem(12) [];
        }

        .other-eat-type-list {
            display: flex;
            justify-content: space-between;
            height: .pxToRem(244) [];
            padding: 0 .pxToRem(40) [];

            .other-eat-type-item {
                width: .pxToRem(314) [];
                height: .pxToRem(244) [];
                border: .pxToRem(4) [] solid #ddd;
                box-sizing: border-box;
                border-radius: .pxToRem(12) [];
                text-align: center;

                .icon {
                    margin-top: .pxToRem(20) [];
                    width: .pxToRem(116) [];
                    height: .pxToRem(116) [];
                }

                .name {
                    margin-top: .pxToRem(8) [];
                    height: .pxToRem(48) [];
                    line-height: .pxToRem(48) [];
                    font-size: .pxToRem(34) [];
                    font-weight: bold;
                    color: #000;
                }

                .tip {
                    font-weight: 500;
                    font-size: .pxToRem(24) [];
                    color: #949494;
                }

                &.select {
                    border-color: @theme_color_first;
                }
            }
        }

        .submit {
            margin: .pxToRem(50) [] auto;
            width: .pxToRem(690) [];
            height: .pxToRem(90) [];
            line-height: .pxToRem(90) [];
            background: @theme_color_first;
            border-radius: .pxToRem(12) [];
            color: white;
            font-size: .pxToRem(32) [];
            text-align: center;
            font-weight: 600;
        }
    }
}

.dy-10733 {
    .content {

        // .customer-service-order-list {
        //     height: .pxToRem(68) [];
        //     .csrl-item {
        //         .icon {
        //             top: .pxToRem(10) [];
        //         }
        //         .title {
        //             top: .pxToRem(12) [];
        //         }
        //         .text {
        //             display: none;
        //         }
        //     }
        // }
        .my-card {
            height: .pxToRem(128) [];
            background: rgba(217, 2, 9, 1);

            .icon {
                background: url('~@/assets/icons/icon-bag-white.png');
                background-size: cover;
            }

            .title {
                font-size: .pxToRem(42) [];
                color: white;
            }
        }
    }
}

.share-page {
    .content {
        top: .pxToRem(430) [];
    }

    .finger {
        display: block;
    }
}

.error-tip {
    .base-center;
    font-size: .pxToRem(32) [];
}
</style>
